import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { Section, withColor, SecondaryButton, Text, Link, Heading4 } from './MarketingStyles';
import { withRouter } from 'react-router-dom'
import config from 'react-global-configuration';

import { inject, observer } from 'mobx-react'

import { trackEvent } from "../../utils/eventTracking"

@inject('utilStore')
@observer
class FeatureSection extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {

    const { features } = this.props.utilStore.util

    return (
      <Section>
        <FeatureGrid>

          { features && features.entries.map((item, index) => (
              <Card key={ 'feature'+index }>
                <CardImage src={`${config.get('CLOUDINARY_URL')}w_400/q_auto:good/${ item.image }.jpg`} />
                <CardContent>
                  <CardSubtitle>{ item.subtitle }</CardSubtitle>
                  <CardTitle>{ item.title }</CardTitle>
                  <CardText>
                    { item.text }
                  </CardText>
                  <SecondaryButton onClick={() => { this.props.history.push("/bewerbung"); trackEvent( 'Apply - Vorteile Detail Page', 'Application', 'Click Button' ) }} value="Jetzt Bewerben" />
                </CardContent>
              </Card>
          ))}
        </FeatureGrid>
      </Section>
    )
  }
}

export default withRouter(FeatureSection)

const CardText = styled(withColor(Text, cssVar.colors.grey)) `
  flex: 1;
  margin-bottom: 30px;
`

const CardLink = withColor(Link, cssVar.colors.grey)

const CardTitle = styled(Text) `
  font-weight: bold;
  font-size: 1.4em;
`

const CardSubtitle = styled(Heading4) `

`

const CardImage = styled.img `
  height: 250px;
  width: 100%;
  object-fit: cover;;
`
const CardContent = styled.div `
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 50px;

  ${cssVar.breakpoints.phone} {
    padding: 30px;
  }
`

const FeatureGrid = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: 1fr;
  grid-gap: 20px;

  ${cssVar.breakpoints.tablet} {
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: auto;
  }

  ${cssVar.breakpoints.phone} {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
  }
`

const Card = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 100%;
  background: ${ cssVar.colors.lightest_grey};
  height: 100%;
`



// WEBPACK FOOTER //
// /src/components/marketing/FeatureSection.js